// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__htlRA","paginationItem":"Pagination_paginationItem__p46NG","activePaginationItem":"Pagination_activePaginationItem__HFSXx"};